import { CSSProperties } from "react";

export type TableColumn = {
  id:
    | "serial_number"
    | "wallet_version"
    | "sending_address"
    // | "spender_address"
    | "risk_level"
    | "no_risk_level_data_count"
    | "select_all"
    | "pending_queue"
    | "sweep_amount";
  labelKey: string;
  minWidth?: CSSProperties["minWidth"];
};

export const TABLE_COLUMNS: readonly TableColumn[] = [
  { id: "serial_number", labelKey: "serial_number" },
  { id: "wallet_version", labelKey: "wallet_version" },
  { id: "sending_address", labelKey: "sending_address", minWidth: 270 },
  // { id: "spender_address", labelKey: "spender_address", minWidth: 270 },
  { id: "risk_level", labelKey: "risk_level", minWidth: 130 },
  {
    id: "no_risk_level_data_count",
    labelKey: "no_risk_level_data_count",
  },
  { id: "pending_queue", labelKey: "pending_queue", minWidth: 130 },
  { id: "select_all", labelKey: "select_all" },
  // { id: "sweepable_amount", labelKey: "sweepable_amount" },
  { id: "sweep_amount", labelKey: "sweep_amount", minWidth: 180 },
] as const;

export type TableColumnId = (typeof TABLE_COLUMNS)[number]["id"];
